import { EditAction } from '../shared/enum/EditAction';
import { ContentModel } from './ContentModel';
import { ExtraParameterModel } from './ExtraParameterModel';
import { KeywordModel } from './KeywordModel';
import { OrganogramDto } from './OrganogramDto';
import { SourceModel } from './SourceModel';
import { SpotlightModel } from './SpotlightModel';

export interface CategoryModel {
    id: number,
    codeMetric: number | null,
    sources: SourceModel[],
    content: ContentModel | null,    
    spotlight: SpotlightModel | null,
    copy: boolean,
    extraParameter: ExtraParameterModel[] | null,
    keywordSelect: KeywordModel[] | null,
    keywordNotSelect: KeywordModel[] | null,
    organograms: OrganogramDto[],
    editAction: EditAction,
    active: boolean
}

export const categoryModelInitial: CategoryModel = {
    id: 0,
    codeMetric: null,
    content: null,
    spotlight: null,
    sources: [],
    copy: false,   
    extraParameter: [],
    keywordSelect: [],
    keywordNotSelect: [],
    organograms: [],
    editAction: EditAction.NONE,
    active: true
};